<template>
  <v-container>
    <div class="mb-2">
      <v-btn @click="dialog = true" color="primary mr-2" v-if="progress.Status !== 'Running' && runAvailable">
        Run
      </v-btn>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>Run script {{ script }}</v-card-title>
          <v-card-text v-for="param in formParams" :key="param.name">
            <v-file-input v-if="param.type === 'file'"
                v-model="param.value"
                :label="param.label"
                dense
            ></v-file-input>
            <v-checkbox v-else-if="param.type === 'checkbox'"
                v-model="param.value"
                :label="param.label"
                dense
            />
            <v-autocomplete v-else-if="param.type === 'select'"
                v-model="param.value"
                :items="param.items"
                :item-text="param.itemText ? param.itemText : 'name'"
                :item-value="param.itemValue ? param.itemValue : 'id'"
                :label="param.label"
                :filter="nonDiacriticsSensitiveFilter"
                clearable
                dense
            />
            <v-autocomplete v-else-if="param.type === 'multipleSelect'"
                v-model="param.value"
                :items="param.items"
                :item-text="param.itemText ? param.itemText : 'name'"
                :item-value="param.itemValue ? param.itemValue : 'id'"
                :label="param.label"
                :filter="nonDiacriticsSensitiveFilter"
                clearable
                multiple
                dense
                chips
                small-chips
                deletable-chips
                :menu-props="{ closeOnContentClick: true }"
            />
            <v-text-field v-else
                v-model="param.value"
                type="text"
                :label="param.label"
                dense
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
            <v-btn color="primary" @click="run">Run</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn @click="getProgress" color="primary mr-2">
        Reload
      </v-btn>
      <v-btn @click="kill" color="red mr-2" v-if="progress.Status === 'Running'">
        Kil progress
      </v-btn>
      <v-btn @click="deleteData" color="red mr-2" v-if="deleteAvailable">
        Delete
      </v-btn>
      <v-btn @click="download" color="green mr-2" v-if="progress['Result file']">
        Download result file
      </v-btn>
    </div>

    <div v-show="Object.keys(progress).length !== 0">
      <v-progress-linear
        v-if="progress.Status === 'Running'"
        v-model="progress['Processed rows percents']"
        height="25"
        class="my-2"
      >
        <strong>{{ Math.ceil(progress['Processed rows percents']) }}%</strong>
      </v-progress-linear>

      <v-simple-table>
        <tbody>
        <tr
          v-for="(value, name) in progress"
          :key="name"
        >
          <td style="min-width: 250px">{{ name }}</td>
          <td v-html="value"></td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'ProgressComponent',
  props: {
    script: {
      type: String,
      default: '',
    },
    progressName: {
      type: String,
      default: '',
    },
    runAvailable: {
      type: Boolean,
      default: true,
    },
    deleteAvailable: {
      type: Boolean,
      default: true,
    },
    formParams: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    progress: {},
    dialog: false,
  }),
  created() {
    this.getProgress();
  },
  methods: {
    run() {
      const formData = new FormData();
      formData.append('script', this.script);

      this.formParams.forEach((param) => {
        formData.append(param.name, param.value);
      });

      this.dialog = false;
      this.progress.Status = 'Running';

      this.$requestHelpers
        .post('api/admin/progress/run', formData, {
          withOverlay: false,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.getProgress();
        });

      setTimeout(() => {
        this.getProgress();
      }, 2000);
    },
    getProgress() {
      this.$requestHelpers
        .post('api/admin/progress/getProgress', {
          script: this.script,
          progressName: this.progressName,
        })
        .then((response) => {
          this.progress = response.data;
        });
    },
    deleteData() {
      this.$confirm('Are you sure you want to delete progress data file?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .post('api/admin/progress/delete', {
            script: this.script,
            progressName: this.progressName,
          })
          .then(() => {
            this.getProgress();
          });
      });
    },
    kill() {
      this.$confirm('Are you sure you want to kill progress?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .post('api/admin/progress/kill', {
            script: this.script,
            progressName: this.progressName,
          })
          .then(() => {
            setTimeout(() => {
              this.getProgress();
            }, 2000);
          });
      });
    },
    download() {
      this.$requestHelpers
        .post('api/admin/progress/download-result', {
          script: this.script,
          progressName: this.progressName,
        },
        {
          responseType: 'blob',
        })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const headerval = response.headers['content-disposition'];
          const filename = headerval.match(/filename=(.*)/);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename[1]);
          fileLink.click();
        });
    },
  },
};
</script>
